module.exports = __webpack_public_path__ + "img/canada-pneumonia-female.b25c4377.png";